/* RESPONSIBLE TEAM: team-omni */
import type AppService from 'embercom/services/app-service';
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import { ReactRoute } from 'embercom/lib/react-route';
import type RouterService from '@ember/routing/router-service';

class BroadcastRoute extends Route {
  @service declare appService: AppService;
  @service declare intl: IntlService;
  @service declare router: RouterService;

  queryParams = {
    mode: {
      refreshModel: false,
    },
  };

  // This will redirect the index /outbound/broadcast route back to /outbound
  redirect(_model: unknown, transition: any): void {
    if (transition?.to?.name === 'apps.app.outbound.broadcast') {
      let broadcastId = transition?.to?.params?.id;

      if (!broadcastId || broadcastId.trim() === '') {
        this.router.transitionTo('apps.app.outbound', this.appService.app.id);
      }
    }
  }

  reactEnabled() {
    return true;
  }

  get titleToken() {
    return this.intl.t('outbound.broadcast.title');
  }
}

export default ReactRoute(BroadcastRoute);
